module.exports = __webpack_public_path__ + "media/application/images/fractured-background@2x-0aa87b4dec1797cf3a81abb8f196ad2d.png";